// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-action-btn__container.MuiFormControl-root {
    width: 100%;    
}

.select-action-btn__container .MuiInputBase-root {
    padding: var(--space-quarter);
    border: 1px solid var(--new-gray-color);
    border-radius: 8px;
    /* margin-top: var(--space-quarter); */
}

.select-action-btn__container .MuiSelect-selectMenu {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 0 12px;
    min-height: 42px;
    color: var(--primary-very-dark-color);
}

.select-action-btn__item.MuiButtonBase-root.MuiMenuItem-root {
    gap: 8px;
}

.select-action-btn__item img,
.select-action-btn__container .MuiButtonBase-root.MuiMenuItem-root img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.select-action-btn__item .icon-ball,
.select-action-btn__container .MuiButtonBase-root.MuiMenuItem-root .icon-ball {
    font-size: 29px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 3px;
    height: 35px;
    color: var(--white-color);
}

.select-action-btn__select .MuiButtonBase-root.MuiMenuItem-root{
    gap: 12px;
}

.select-action-btn__container .MuiInput-underline:before {
    content: initial;
    transition: none;
    border-bottom: none;
    pointer-events: none;
}

.select-action-btn__container .MuiSelect-select:focus {
    background-color: transparent;
}

.select-action-btn__container .MuiListItemText-multiline {
    margin-top: 0px;
    margin-bottom: 0px;
}

.select-action-btn__placeholder {
    margin: 8px 12px;
}

.select-action-btn__add-option.MuiButtonBase-root {
    background-color: var(--new-background-color);
    margin: 12px 8px;
    padding: 10px 6px;
    border-radius: 4px;
    align-items: center;
    gap: 12px;
    color: var(--new-green-color);
}

.select-action-btn__add-option .hubicon-add_option {
    font-size: 18px;
}

.select-action-btn__add-option .baloa-username {
    font-weight: var(--font-medium);
    color: var(--new-green-color);
}

.select-action-btn__placeholder.MuiListItem-root.Mui-disabled {
    display: none;
}


.select-action-btn__options .MuiButtonBase-root.MuiMenuItem-root {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) - 1px);/*15px*/
    line-height: normal;    
    letter-spacing: 0.0025em;
    color: var(--primary-very-dark-color);
}

.select-action-btn__container .MuiAutocomplete-popper.MuiAutocomplete-popperDisablePortal {
    transform: translate(0, 75px) !important;
}

.select-action-btn__select .MuiInputBase-root {
    background: var(--white-color);
}

.select-action-btn__select.selected .MuiButtonBase-root.MuiMenuItem-root:hover {
    background: var(--white-color);
}

.select-action-btn__select.selected .MuiButtonBase-root.MuiMenuItem-root {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.select-action-btn__select.selected .MuiListItemSecondaryAction-root{
    background: var(--new-gray-background-color);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
}

.select-action-btn__select .selected .MuiFormControl-root.MuiTextField-root {
    margin-top: 4px;
}

.select-action-btn__select .MuiInputBase-root.MuiOutlinedInput-root {
    padding: 6px;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/select-action-btn/SelectActionBtnComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;IACvC,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC,CAAC,OAAO;IAC3C,mBAAmB;IACnB,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".select-action-btn__container.MuiFormControl-root {\n    width: 100%;    \n}\n\n.select-action-btn__container .MuiInputBase-root {\n    padding: var(--space-quarter);\n    border: 1px solid var(--new-gray-color);\n    border-radius: 8px;\n    /* margin-top: var(--space-quarter); */\n}\n\n.select-action-btn__container .MuiSelect-selectMenu {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    padding: 0 12px;\n    min-height: 42px;\n    color: var(--primary-very-dark-color);\n}\n\n.select-action-btn__item.MuiButtonBase-root.MuiMenuItem-root {\n    gap: 8px;\n}\n\n.select-action-btn__item img,\n.select-action-btn__container .MuiButtonBase-root.MuiMenuItem-root img {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n}\n\n.select-action-btn__item .icon-ball,\n.select-action-btn__container .MuiButtonBase-root.MuiMenuItem-root .icon-ball {\n    font-size: 29px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 3px;\n    height: 35px;\n    color: var(--white-color);\n}\n\n.select-action-btn__select .MuiButtonBase-root.MuiMenuItem-root{\n    gap: 12px;\n}\n\n.select-action-btn__container .MuiInput-underline:before {\n    content: initial;\n    transition: none;\n    border-bottom: none;\n    pointer-events: none;\n}\n\n.select-action-btn__container .MuiSelect-select:focus {\n    background-color: transparent;\n}\n\n.select-action-btn__container .MuiListItemText-multiline {\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n\n.select-action-btn__placeholder {\n    margin: 8px 12px;\n}\n\n.select-action-btn__add-option.MuiButtonBase-root {\n    background-color: var(--new-background-color);\n    margin: 12px 8px;\n    padding: 10px 6px;\n    border-radius: 4px;\n    align-items: center;\n    gap: 12px;\n    color: var(--new-green-color);\n}\n\n.select-action-btn__add-option .hubicon-add_option {\n    font-size: 18px;\n}\n\n.select-action-btn__add-option .baloa-username {\n    font-weight: var(--font-medium);\n    color: var(--new-green-color);\n}\n\n.select-action-btn__placeholder.MuiListItem-root.Mui-disabled {\n    display: none;\n}\n\n\n.select-action-btn__options .MuiButtonBase-root.MuiMenuItem-root {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) - 1px);/*15px*/\n    line-height: normal;    \n    letter-spacing: 0.0025em;\n    color: var(--primary-very-dark-color);\n}\n\n.select-action-btn__container .MuiAutocomplete-popper.MuiAutocomplete-popperDisablePortal {\n    transform: translate(0, 75px) !important;\n}\n\n.select-action-btn__select .MuiInputBase-root {\n    background: var(--white-color);\n}\n\n.select-action-btn__select.selected .MuiButtonBase-root.MuiMenuItem-root:hover {\n    background: var(--white-color);\n}\n\n.select-action-btn__select.selected .MuiButtonBase-root.MuiMenuItem-root {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.select-action-btn__select.selected .MuiListItemSecondaryAction-root{\n    background: var(--new-gray-background-color);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n}\n\n.select-action-btn__select .selected .MuiFormControl-root.MuiTextField-root {\n    margin-top: 4px;\n}\n\n.select-action-btn__select .MuiInputBase-root.MuiOutlinedInput-root {\n    padding: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
